import { useEffect, useState } from "react";
import api from "../services/api";

export default function TarifsRegionsPage() {
  const [regions, setRegions] = useState([]);
  const [saving,  setSaving]  = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    api.get("/admin/tarifs-regions").then(res => setRegions(res.data));
  }, []);

  const save = async (region) => {
    setSaving(region.id);
    try {
      await api.put(`/admin/tarifs-regions/${region.id}`, region);
      setSuccess(region.id);
      setTimeout(() => setSuccess(null), 2000);
    } catch (err) {
      console.error(err);
    }
    setSaving(null);
  };

  const update = (id, field, value) => {
    setRegions(prev => prev.map(r =>
      r.id === id ? { ...r, [field]: value } : r
    ));
  };

  const columns = [
    { field: "prix_base",    label: "Base (CFA)",    step: 50  },
    { field: "prix_par_km",  label: "Par km (CFA)",  step: 50  },
    { field: "prix_par_min", label: "Par min (CFA)", step: 5   },
    { field: "prix_minimum", label: "Min (CFA)",     step: 50  },
    { field: "multiplicateur", label: "Multiplicateur", step: 0.1 },
    { field: "heure_pointe_multiplicateur", label: "Heure pointe", step: 0.05 },
    { field: "frais_approche_1km", label: "< 1km",  step: 50  },
    { field: "frais_approche_2km", label: "1-2km",  step: 50  },
    { field: "frais_approche_3km", label: "2-3km",  step: 50  },
    { field: "frais_approche_4km", label: "3-4km",  step: 50  },
    { field: "frais_approche_5km", label: "> 4km",  step: 50  },
  ];

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>🗺️ Tarifs par région</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>
            Prix dynamiques par région — base + km + min + approche × multiplicateur
          </p>
        </div>
        <div style={{ fontSize: 12, padding: "4px 14px", borderRadius: 20, background: "#E6F1FB", color: "#185FA5", border: "0.5px solid #B5D4F4" }}>
          🗺️ {regions.length} régions
        </div>
      </div>

      {/* Formule */}
      <div style={{ background: "#f7f7f7", borderRadius: 10, padding: 14, marginBottom: 16, fontSize: 13, color: "#0B3C5D" }}>
        💡 <strong>Formule :</strong> (Base + km × dist + min × durée + frais approche) × multiplicateur région × multiplicateur heure de pointe
      </div>

      {/* Table scrollable */}
      <div style={{ background: "#fff", borderRadius: 12, border: "0.5px solid #e5e5e5", overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              <th style={{ padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 500, color: "#fff", position: "sticky", left: 0, background: "#0B3C5D" }}>
                Région
              </th>
              {columns.map(c => (
                <th key={c.field} style={{ padding: "12px 10px", textAlign: "center", fontSize: 11, fontWeight: 500, color: "#fff", whiteSpace: "nowrap" }}>
                  {c.label}
                </th>
              ))}
              <th style={{ padding: "12px 14px", textAlign: "center", fontSize: 12, fontWeight: 500, color: "#fff" }}>Actif</th>
              <th style={{ padding: "12px 14px", textAlign: "center", fontSize: 12, fontWeight: 500, color: "#fff" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {regions.map(r => (
              <tr key={r.id} style={{
                borderBottom: "0.5px solid #f0f0f0",
                background: success === r.id ? "#EAF3DE" : "white",
                transition: "background 0.3s",
              }}>

                {/* Région */}
                <td style={{ padding: "10px 14px", fontWeight: 600, color: "#0B3C5D", position: "sticky", left: 0, background: "white", whiteSpace: "nowrap" }}>
                  {r.region}
                </td>

                {/* Champs numériques */}
                {columns.map(c => (
                  <td key={c.field} style={{ padding: "8px 6px", textAlign: "center" }}>
                    <input
                      type="number"
                      step={c.step}
                      value={r[c.field] ?? 0}
                      onChange={e => update(r.id, c.field, parseFloat(e.target.value))}
                      style={{
                        width: 70, padding: "5px 6px", borderRadius: 6, textAlign: "center",
                        border: "0.5px solid #ddd", fontSize: 12, color: "#0B3C5D",
                        outline: "none",
                      }}
                    />
                  </td>
                ))}

                {/* Actif */}
                <td style={{ padding: "10px 14px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={r.actif ?? true}
                    onChange={e => update(r.id, "actif", e.target.checked)}
                    style={{ width: 16, height: 16, cursor: "pointer" }}
                  />
                </td>

                {/* Sauver */}
                <td style={{ padding: "10px 14px", textAlign: "center" }}>
                  <button
                    onClick={() => save(r)}
                    disabled={saving === r.id}
                    style={{
                      padding: "6px 14px", borderRadius: 6, border: "none",
                      background: success === r.id ? "#3B6D11" : saving === r.id ? "#ccc" : "#0B3C5D",
                      color: "#fff", fontSize: 12,
                      cursor: saving === r.id ? "default" : "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {success === r.id ? "✅ Sauvé" : saving === r.id ? "..." : "💾 Sauver"}
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Aperçu calcul */}
      <div style={{ marginTop: 20, background: "#fff", borderRadius: 12, padding: 20, border: "0.5px solid #e5e5e5" }}>
        <p style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D", marginBottom: 12 }}>
          🧮 Simulateur de prix — Saint-Louis
        </p>
        {regions.filter(r => r.region === "Saint-Louis").map(r => {
          const dist = 5, duree = 10, approche = r.frais_approche_2km ?? 100;
          const multiplicateurRegion = r.multiplicateur ?? 1.0;
          const multiplicateurHeure = r.heure_pointe_multiplicateur ?? 1.25;

          const prixBrut =
            ((r.prix_base ?? 500) +
             (r.prix_par_km ?? 300) * dist +
             (r.prix_par_min ?? 10) * duree +
             approche) *
            multiplicateurRegion *
            multiplicateurHeure;

          const prix = Math.max(
            Math.round(prixBrut / 100) * 100,
            r.prix_minimum ?? 500
          );
          return (
            <div key={r.id} style={{ fontSize: 13, color: "#555" }}>
              <div>Trajet 5km, 10 min, chauffeur à 1.5km :</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#0B3C5D", marginTop: 6 }}>
                {prix.toLocaleString("fr-FR")} CFA
              </div>
                <div style={{ fontSize: 12, color: "#aaa", marginTop: 4 }}>
                   Base {r.prix_base} + km {Math.round((r.prix_par_km ?? 300) * dist)} + durée {Math.round((r.prix_par_min ?? 10) * duree)} + approche {approche}
                   {" × région "}{multiplicateurRegion}
                   {" × pointe "}{multiplicateurHeure}
                </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}